export default __webpack_public_path__ + "static/media/Boots of the Howling Giant.8d644b0c.jpg";